// extracted by mini-css-extract-plugin
export default {"logo":"Footer_logo__hCrGh","contact":"Footer_contact__AT+k-","copyright":"Footer_copyright__RMJ1y"};